module.exports = ".form-control {\n  background-color: antiquewhite; }\n"